export default "__VITE_ASSET__CO$a1dM___"